<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="calibre_pb_0">
<span id="pgepubid00046" title="[43]"><a id="Page_43"></a></span>
<h2 class="nobreak" id="pgepubid00047">CHAPTER IV</h2>
</div>
<p class="pcalibre drop-cap">THE great day dawned at last; the day of the
Hunt Ball, which took place annually in the
Town Hall of Ridgefield, and was attended by everybody
who was anyone—and many nobodies.</p>
<p class="calibre7">Letty’s white <i class="calibre18">crêpe</i>, completed with her assistance,
was charming; soft, girlish, and yet distinguished—for
her mental eye had copied it from one of the trousseau
gowns of a young and royal princess.</p>
<p class="calibre7">Mrs. Fenchurch, who was not remarkable for her
taste in dress, wore a ginger-coloured velvet, with opal
ornaments; but she carried herself with dignity and
looked a Claremont, and a personage! Colonel Fenchurch,
in his pink coat, black satin breeches, and neat
silk stockings, squeezed himself into the brougham,
with many compliments for his two companions.</p>
<p class="calibre7">The town of Ridgefield was eight miles away, and as
the family bowled along the road at a steady pace, the
Colonel dozed, his wife meditated with closed eyes;
but their niece all the time stared out on the brown
hedges and bare ditches, which were illuminated by
the flashing carriage lamps. Of what was she thinking?
Was it possible that she was wondering if Lancelot
Lumley would be at the ball?</p>
<p class="calibre7">The Holt party were somewhat late arrivals, and<span id="pgepubid00048" title="[44]"><a id="Page_44"></a></span>
when the carriage drew up under an awning in front
of the Town Hall, the first to step out and run the
gauntlet of many spectators was Colonel Fenchurch.
He had a remarkably well-turned leg, and looked particularly
spruce. His wife followed with impressive
deliberation, and last of all came the young lady in
white. Her appearance was greeted with a loud
murmur, as she floated up the steps in the wake of her
relations.</p>
<p class="calibre7">As they left the cloak-room, Mrs. Fenchurch, who
had received many greetings, was confronted with a
lady in a superb sable cloak; a handsome woman with
flashing black eyes, and wearing in her hair a magnificent
diamond ornament.</p>
<p class="calibre7">“Oh, Mrs. Fen,” she exclaimed, “how are you?
Going strong, eh?” Then her eyes suddenly alighted
on Mrs. Fen’s companion, and she gave her a hard,
critical stare.</p>
<p class="calibre7">“Ah, I suppose this little girl is the niece? going to
take her preliminary canter?” and with a patronising
nod, she passed on to the dressing-room.</p>
<p class="calibre7">Letty encountered her aunt’s eye, who, seizing her
arm to lead her forward, said:</p>
<p class="calibre7">“That is Mrs. Flashman, a wonderful rider, but an
odious, detestable creature, who slams gates, jostles you
at fences, and swears at her horses, and her servants.”</p>
<p class="calibre7">Two minutes later, Miss Glyn found herself with a
programme in her hand, standing in the ball-room.
This was beautifully decorated, a military band was
established in the gallery, and the sides of the room<span id="pgepubid00049" title="[45]"><a id="Page_45"></a></span>
and a sort of platform at the upper end were densely
crowded with guests. Others were promenading up
and down impatiently awaiting the next waltz. Many
neighbours had brought large house-parties, whose
smart gowns and splendid jewels, gave an air of
London society to the Brakesley Hunt Ball.</p>
<p class="calibre7">Mrs. Fenchurch paced slowly towards the dais. On
her way, she encountered several acquaintances, and
introduced her niece to Lord Seafield—a thin young
man with a very prominent nose and no chin—to Sir
Edgar Broome, the M.F.H., and to the Dowager
Duchess of Campshire.</p>
<p class="calibre7">Before ascending the platform, she was accosted
by Lancelot Lumley, who came forward eagerly, programme
in hand, and said:</p>
<p class="calibre7">“I hope Miss Glyn can spare me a couple of
waltzes?”</p>
<p class="calibre7">Miss Glyn promptly produced her programme, and he
scribbled his initials before three. The next, which
was just beginning, the one before supper, and number
twelve.</p>
<p class="calibre7">Mrs. Fenchurch looked on with glum disapproval.
<i class="calibre18">Three</i> dances to an impecunious subaltern! But she
could not offer any audible objection, and as the band
struck up he said:</p>
<p class="calibre7">“Shall we make a start now before the room gets
crammed?” and light as a feather the young lady was
whirled away, and the elder was compelled to mount
to the platform alone. But from this and other coigns
of vantage, the extraordinary beauty of Miss Glyn was<span id="pgepubid00050" title="[46]"><a id="Page_46"></a></span>
soon remarked. Indeed, her own chaperon, as she
surveyed her through her best gold glasses, assured
herself, that she had never until now realised the girl’s
astonishing good looks! Of course dress went a long
way, so did youth—and candle-light; but Letty’s
profile was perfect, her complexion, the shape of her
face, the setting on of her head, were beyond criticism—and
then her grace!</p>
<p class="calibre7">As Dorothy Fenchurch watched the white form
revolving round and round, she began to experience
an intoxicating sensation; the stimulating conviction
was borne in upon her, that she had a valuable prize
to offer in the marriage market!</p>
<p class="calibre7">Seen just at home, running about in her school
frocks and garden apron, Letty was merely a pretty
girl, with lots of hair, and a good complexion; here,
in the midst of the magnates of the land, she was the
beauty of the evening! People—her neighbours—gathered
about Mrs. Fenchurch and began to talk,
discussing local news, the recent weather, the various
notable magnates who had honoured the ball.</p>
<p class="calibre7">“I say, Mrs. Fen, have you noticed the lovely nymph
in white and silver?” enquired the Secretary of the
Hunt. “I haven’t seen anything so exquisite for
years; <i class="calibre18">do</i> let me show her to you?”</p>
<p class="calibre7">“There is no occasion, thank you, she is my niece,
Miss Glyn,” proclaimed the uplifted aunt.</p>
<p class="calibre7">“What—your niece?” echoed a matron. “Why,
my dear lady, where have you kept her all this
time?”</p>
<p class="calibre7"><span id="pgepubid00051" title="[47]"><a id="Page_47"></a></span>“She has only been with us about two months.”</p>
<p class="calibre7">“And you have defrauded us of two months,” burst
in a young man. “Mrs. Fen, how dared you?”</p>
<p class="calibre7">“No, no,” protested Mrs. Flashman of the bold eyes
and a scandalously <i class="calibre18">décolleté</i> dress. “Mrs. Fenchurch
is a clever woman. She understands the art of an effective
surprise!”</p>
<p class="calibre7">By this time the music had ceased, and Miss Glyn,
a little breathless and looking radiantly happy, was
brought back to her aunt—now encompassed by a
number of men clamouring for introductions. In the
midst of this triumphant scene, a square-shouldered
individual, perfectly groomed, with the blue of his
strong beard showing through his heavy, clean-shaven
face, stepped up on the platform. It was the psychological
moment! Here was the girl he had noticed at
the gate, surrounded by competitive partners, and he
said to himself, “No wonder!” This dazzling vision
in white and silver, eclipsed every woman in the room!
He accosted Mrs. Fenchurch with unusual <i class="calibre18">empressement</i>,
and then glanced interrogatively at her companion.</p>
<p class="calibre7">“Oh, let me present you to my niece—Mr. Blagdon—Miss
Glyn,” she murmured with effusive haste.</p>
<p class="calibre7">“Got any dances to spare?” he asked with an off-hand
air.</p>
<p class="calibre7">“Yes,” she answered; “I have two or three left—but——”</p>
<p class="calibre7">“Are you engaged for the next?” he interrupted
brusquely.</p>
<p class="calibre7"><span id="pgepubid00052" title="[48]"><a id="Page_48"></a></span>As this happened to be a set of Lancers, she breathed
a reluctant “No.”</p>
<p class="calibre7">“Oh, then <i class="calibre18">I</i> may have it?” he declared, confronting
her with a bold and confident eye. As she
yielded her card, he wrote himself down for this, as
well as two others (which Letty had secretly been
keeping for Lancelot Lumley). “H. Blagdon” was
also marked before an extra; but a man with many
thousands a year is granted a liberal margin. Mrs.
Fenchurch was looking on; her eyes glittered, a real
colour came into her thin cheeks. Supposing that he
had taken a fancy to Letty? It would be too wonderful
to think of! The most promising suitor she had
allowed herself to expect, was some officer from a
neighbouring depôt; but then, until that evening she
had never fully understood the value of the treasure
she had hidden at The Holt. Now, her ambition,
determination, and energy, were stirred, and she was
resolved that Letty should make a <i class="calibre18">great</i> match.
Everyone knew that Hugo Blagdon ‘barred girls’:
he never noticed them, never danced with them—indeed,
he rarely danced at all—generally he sat in a
remote corner with some notorious married woman—yet
here he was, filling up the programme of her niece,
and devouring her shy beauty with his hard, bold eyes.</p>
<p class="calibre7">Undoubtedly most people liked to look at Letty.
Was there ever such a perfect little nose, such a
short upper lip, delicately cut mouth, or sweeping
black lashes?</p>
<p class="calibre7">Presently the Lancers struck up, and Blagdon, offering<span id="pgepubid00053" title="[49]"><a id="Page_49"></a></span>
his arm, conducted his partner down the room, as
it were in triumph; undoubtedly she was the star of
the evening! As he passed along, he noticed that the
eyes of everyone were fixed upon his companion. This
was just the sort of girl that would suit him for a wife!
a girl so remarkable, so absolutely perfect in appearance,
that all the jealous world would stare at her
open-mouthed.</p>
<p class="calibre7">Having invited an aristocratic <i class="calibre18">vis-à-vis</i>, they took
their places in a set and danced. Blagdon found Miss
Glyn shy—she had not much to say for herself. With
difficulty he gathered that she didn’t hunt, had only
lately left school, and was seventeen last birthday;
but it was sufficiently agreeable for him to feel that
she was the cynosure of all eyes, and that he was the
envy of every man in the room!</p>
<p class="calibre7">Mrs. Flashman, who was in the same set, swam
hither and thither in her gorgeous French gown, and
now and then darted glances of sarcastic amusement
at her friend Hugo and the little baby; and whispered
<i class="calibre18">en passant</i> in the Grand Chain:</p>
<p class="calibre7">“<i class="calibre18">Where</i> is the bread and butter?”</p>
<p class="calibre7">The remainder of that evening was, from her aunt’s
point of view, an uninterrupted triumph for Letty: a
number of influential people had begged to make her
acquaintance; envious and rancorous rivals—mothers
of large families, had uttered spiteful things about
Hugo Blagdon. He had taken her niece to supper,
had only danced with her that night, and when not
dancing, had posted himself where he could keep her<span id="pgepubid00054" title="[50]"><a id="Page_50"></a></span>
in view—all of which signs and tokens even the most
comatose chaperon could not fail to note! Oh, it
was undoubtedly a case.</p>
<p class="calibre7">Had Letty enjoyed her first ball? She was not sure.
She enjoyed dancing with Mr. Lumley and with various
other young men; she enjoyed the band, and the ices,
and loved dancing for dancing’s sake, but somehow
there seemed to be between Mr. Lumley and Mr.
Blagdon a sharp but secret conflict for her company.
When she was swinging round in the arms of Mr.
Lumley, she was aware that the other was watching
them closely; and when it was Blagdon’s dance he
stalked up and claimed her with an air of appropriation,
that she found both disagreeable and disconcerting.</p>
<p class="calibre7">However she danced the last waltz that evening
with the soldier—who informed her that he had come
all the way from Aldershot on purpose to claim her
promise! He was so good-looking, he had a charming
voice and such nice eyes; little Letty’s heart beat
quickly, and the colour came into her cheeks.</p>
<p class="calibre7">“Give my love to Aunt Harriet,” he said; “and
tell her that I will run over and see her before very
long, and stay three or four days.”</p>
<p class="calibre7">For a moment the girl felt ecstatically happy, inspired
by an unreasoning joy and strangely moved and uplifted;
but it was Mr. Blagdon who escorted her to
have a cup of soup at the buffet before she departed,
who stared at her with an expression that frightened
her, and who conducted her down to the entrance hall
through a long line of spectators. And never had<span id="pgepubid00055" title="[51]"><a id="Page_51"></a></span>
Letty known her aunt to be so gracious, so affectionate,
or in such talkative good-humour; she had
actually called her ‘darling!’</p>
<p class="calibre7">“I hope you are well wrapped up,” she urged;
“take care of your dress, darling.”</p>
<p class="calibre7">“And mind <i class="calibre18">you</i> take great care of her,” supplemented
Blagdon at the carriage window. He held out
his hand to Letty, kept hers an unnecessary length of
time, and squeezed it painfully ere he closed the door
of the brougham and they drove off. The last object
she beheld, thrown into sharp relief by the glaring
lamps and red carpet, was his hard, staring brown
eyes, his stolid, complacent face, and she sank into her
corner with a sigh of relief. Thank goodness she would
never see him again!</p>
<p class="calibre7">She was to hear of him, however! On the way
home her aunt loudly sang the praises of Hugo Blagdon,
the richest man in the county. He had the most lovely
place, and was so popular; he had travelled a great
deal, and owned a yacht and a coach, indeed everything—just
like a prince in a fairy tale. During all
these eulogiums and dazzling descriptions Colonel
Fenchurch maintained an unusual silence.</p>
<p class="calibre7">“What do you think of him, Letty?” he enquired
at last.</p>
<p class="calibre7">“He dances well,” she answered carelessly, “though
he soon gets out of breath, and has rather an old-fashioned
step.”</p>
<p class="calibre7">“Well, there is not a woman in this part of the world
that isn’t delighted to have him for a partner,” said<span id="pgepubid00056" title="[52]"><a id="Page_52"></a></span>
her aunt, with an air of finality; then, changing the
subject, she proceeded to discuss the ball in detail,
from the decorations to the soup. Her remarks about
the guests—especially girls—were not altogether
generous; now that she had, so to speak, her own
goods to offer, Mrs. Fenchurch was a merciless critic
of the wares of others.</p>
<p class="calibre7">“Did you notice Lady Vera, Tom? She’s supposed
to be a beauty, a tall, scraggy, spotty creature, with
a wreath over her nose?” A pause. “And how <i class="calibre18">can</i>
Mrs. Reed allow her daughters to be seen in such filthy
frocks!—anything good enough for the country.
Those poor Bradfields hardly left their seats—<i class="calibre18">so</i>
humiliating for a chaperon to have her charges on
hand all the time—what do you say, Tom?”</p>
<p class="calibre7">But Tom’s sole reply was a gentle snore.</p>
<p class="calibre7">Then, turning to Letty and stroking her arm, her
aunt said:</p>
<p class="calibre7">“My dear child, you were perfectly right about the
white <i class="calibre18">crêpe</i>, you looked charming—charming! I was
proud of you!” and as she pinched her wrist, playfully,
the girl, with the quick insight of youth, divined
that here was an entirely different relative to the one
who had told her she was a ‘pauper, and a burden.’
She now addressed her, as if she were an equal—and
indeed there was actually a tinge of deference in her
remarks. What did it mean?</p>
<p class="calibre7">The Belle of the Hunt Ball toiled up to bed tired
and footsore at five o’clock in the morning. She had
enjoyed the evening immensely, and yet she had not<span id="pgepubid00057" title="[53]"><a id="Page_53"></a></span>
enjoyed it! On the one hand, there was the dancing,
the good partners, the charming things people had
said to her, and the agreeable inward conviction of
having been whispered about, and admired; on the
other, there was the rich man, with his staring eyes
and brusque, imperious manner—and the inexplicable
rise in the temperature of her aunt’s affection. What
did it mean?</p>
<p class="calibre7">And still wondering, Letty tumbled into bed, and
presently entered the land of dreams.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0005.vue?d9b5919c